import React from 'react';
import './Terms.css';

const PrivacyPolicyDE = () => {
  return (
    <div className="terms-page">
      <h1>Datenschutzerklärung</h1>
      <div className="terms-main">
        <p>
          <strong>Rewards & Samples, LLC</strong> ("wir", "unser" oder "uns") bietet die folgende 
          Datenschutzerklärung ("Datenschutzerklärung" oder "Richtlinie"), die unsere Praktiken 
          im Zusammenhang mit der Erfassung, Verwendung, Offenlegung und dem Verkauf von 
          Informationen festlegt, die persönlich identifizierbar für einen Benutzer sind 
          ("Informationen").
        </p>

        <h3>1. ANNAHME DER DATENSCHUTZERKLÄRUNG</h3>
        <p>
          Durch den Zugriff auf und die Nutzung unserer Website, die wir besitzen und betreiben 
          und die Belohnungen und/oder andere Inhalte für Benutzer anbietet (zusammen die "Website"), 
          erklären Sie sich mit dieser Datenschutzerklärung einverstanden und stimmen der Erfassung, 
          Verwendung, Offenlegung und dem Verkauf Ihrer Informationen wie hierin beschrieben zu.
        </p>

        <h3>2. ARTEN VON INFORMATIONEN, DIE WIR SAMMELN</h3>
        <p>
          Wir können die folgenden Arten von Informationen über Benutzer sammeln:
        </p>
        <ul>
          <li>Identifizierbare Informationen wie Name, Postanschrift, E-Mail-Adresse(n), 
          Mobiltelefonnummer(n), Geburtsdatum und Geschlecht</li>
          <li>Informationen, die aus den Antworten eines Benutzers auf Umfragefragen gesammelt 
          werden, einschließlich Präferenzen und persönlicher Attribute</li>
          <li>Von unseren Webserver-Protokolldateien gesammelte Informationen, einschließlich 
          Gerätetyp(en), Benutzer-Agent-Daten, verweisende URL(s) und IP-Adresse(n)</li>
          <li>Informationen über die Interaktion eines Benutzers mit Telemarketing-Anrufen, 
          SMS-Nachrichten, Push-Benachrichtigungen, kommerziellen E-Mails und anderen 
          Kommunikationsformen</li>
        </ul>

        <h3>3. VERWENDUNG VON COOKIES</h3>
        <p>
          Unsere Website verwendet Cookies, um festzustellen, ob Benutzer die Website zuvor besucht 
          haben, und um den Registrierungsprozess zu optimieren. Wir können Cookies auch verwenden, 
          um das Erlebnis eines Benutzers auf der Website zu verbessern.
        </p>

        <h3>4. GDPR-RECHTE</h3>
        <p>
          Gemäß der Datenschutz-Grundverordnung (GDPR) haben Sie folgende Rechte:
        </p>
        <ul>
          <li><strong>Auskunftsrecht:</strong> Sie haben das Recht, Auskunft über Ihre 
          personenbezogenen Daten zu erhalten</li>
          <li><strong>Recht auf Berichtigung:</strong> Sie haben das Recht, unrichtige 
          personenbezogene Daten berichtigen zu lassen</li>
          <li><strong>Recht auf Löschung:</strong> Sie haben das Recht, die Löschung Ihrer 
          personenbezogenen Daten zu verlangen</li>
          <li><strong>Recht auf Einschränkung der Verarbeitung:</strong> Sie haben das Recht, 
          die Einschränkung der Verarbeitung zu verlangen</li>
          <li><strong>Recht auf Datenübertragbarkeit:</strong> Sie haben das Recht, Ihre Daten 
          in einem strukturierten Format zu erhalten</li>
          <li><strong>Widerspruchsrecht:</strong> Sie haben das Recht, der Verarbeitung Ihrer 
          personenbezogenen Daten zu widersprechen</li>
        </ul>

        <h3>5. DATENÜBERMITTLUNG</h3>
        <p>
          Ihre Informationen können an Server außerhalb des Europäischen Wirtschaftsraums (EWR) 
          übertragen und dort gespeichert werden. Durch die Nutzung unserer Dienste stimmen Sie 
          dieser Übertragung zu.
        </p>

        <h3>6. DATENSICHERHEIT</h3>
        <p>
          Wir verwenden wirtschaftlich angemessene Anstrengungen, um unbefugten Zugriff, 
          Offenlegung oder versehentlichen Verlust oder Zerstörung Ihrer Informationen zu 
          verhindern. Der Zugriff auf Ihre Informationen ist streng begrenzt.
        </p>

        <h3>7. ÄNDERUNGEN DIESER RICHTLINIE</h3>
        <p>
          Wir behalten uns das Recht vor, diese Richtlinie jederzeit zu überarbeiten und zu 
          aktualisieren. Wesentliche Änderungen werden auf der Website veröffentlicht und 
          treten dreißig (30) Tage nach der Veröffentlichung in Kraft.
        </p>

        <h3>8. KONTAKT</h3>
        <p>
          Wenn Sie Fragen, Kommentare oder Vorschläge zu dieser Richtlinie oder der Website 
          haben, kontaktieren Sie uns bitte.
        </p>

        <div className="last-updated">
          Zuletzt aktualisiert: Januar 2026
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyDE;
